var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-widget-group-list"},[_vm._l((_vm.list),function(item){return _vm._t("item",null,null,item)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }